<div class="modal-details p-16">
    <h1>{{ "APP_CASES.PARASHIFT_TAINING_VOTING" | translate }}</h1>

    <div fxLayout="column" [formGroup]="parashiftTrainingForm" fxLayoutGap="16px" class="mt-8">
        <div fxLayout="row">
            <mat-form-field fxFlex="50" appearance="outline" class="form-field-width">
                <mat-label>{{ "APP_CREATE_CASE.VOTE" | translate }}</mat-label>
                <mat-select class="form-placeholder" formControlName="Vote">
                    <mat-option
                        class="form-placeholder"
                        *ngFor="let option of parashiftTrainingVotingOption"
                        [value]="option.Value"
                    >
                        {{ option.Key | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <span class="font-size-16 font-weight-600 dark-text-65">{{ "APP_CASES_REPORT.REMARK" | translate }}</span>
            <div class="w-100-p mt-16 pr-8" fxLayout="column">
                <app-basic-ckeditor
                    class="min-editor"
                    fxFlex
                    fxFlexFill
                    [ckEditorConfig]="ckEditorConfig"
                    [ckEditorContent]="parashiftTrainingForm.controls['Comment'].value | ContentFormating"
                    (editorChange)="parashiftTrainingForm.controls['Comment'].setValue($event)"
                >
                </app-basic-ckeditor>
            </div>
        </div>
        <div fxLayout="row" class="mt-16" fxLayoutAlign="end center">
            <button mat-flat-button class="col-green mr-8" (click)="onModalClose()">
                <span class="font-weight-700 spaced-letter">{{ "APP_CASES.CANCEL" | translate | uppercase }}</span>
            </button>
            <button mat-flat-button color="primary" (click)="saveVoting()">
                <span class="font-weight-700 spaced-letters-2p">{{ "APP_CASES.SAVE" | translate | uppercase }}</span>
            </button>

            <mat-spinner [diameter]="20" *ngIf="isSavedTrainingVoting" class="mr-8 ml-20"> </mat-spinner>
        </div>
    </div>
</div>
